import React, { useRef } from 'react'
import clsx from 'clsx'
import circle1 from '@/assets/icons/advatages-grid-item-bg-2.svg'
import circle2 from '@/assets/icons/happy_clients.svg'
import { MenuFilterProps } from '@/components/organisms/VideoLibrarySection/types'

export default function MenuFilter({
  menuItems,
  setCategory,
  allVideosLabel,
  featuredLabel,
  categoriesLabel
}: MenuFilterProps) {
  const allVideosRef = useRef<HTMLInputElement>(null)
  const featuredRef = useRef<HTMLInputElement>(null)
  const menuItemsRef = useRef<HTMLInputElement[]>([])

  return (
    <div className="netbook:w-1/4">
      <div className="w-[275px] flex flex-col gap-8 rounded px-8 pt-24 pb-24 text-bodyM text-text-dark-900 bg-primary-100 sticky top-80 overflow-hidden ">
        <img src={circle1} alt="circe" className="w-[36px] absolute top-0 -left-16" />
        <img src={circle2} alt="circe" className="w-[170px] absolute -bottom-128 -right-112 rotate-12" />
        <p className="font-poppins leading-30 tracking-wide text-bodyL uppercase font-bold ml-16 mb-16 text-primary-600">
          {categoriesLabel}
        </p>
        <div
          className={clsx(
            'flex items-center  px-16 rounded-md hover:text-white hover:bg-primary-500',
            allVideosRef?.current?.checked ? 'bg-primary-900 text-white font-bold' : ''
          )}
        >
          <input
            ref={allVideosRef}
            type="radio"
            name="categories"
            id="all_videos"
            value={allVideosLabel}
            onChange={(e) => setCategory(e.target.value)}
            className="cursor-pointer appearance-none"
          />
          <label className="cursor-pointer w-full py-12" htmlFor="all_videos">
            {allVideosLabel}
          </label>
        </div>
        <div
          className={clsx(
            'flex items-center  px-16 rounded-md hover:text-white hover:bg-primary-500',
            featuredRef?.current?.checked ? 'bg-primary-900 text-white font-bold' : ''
          )}
        >
          <input
            ref={featuredRef}
            type="radio"
            name="categories"
            id="featured"
            value={featuredLabel}
            onChange={(e) => setCategory(e.target.value)}
            className="cursor-pointer appearance-none "
          />
          <label className="cursor-pointer py-12 w-full" htmlFor="featured">
            {featuredLabel}
          </label>
        </div>

        {menuItems.map((item, index) => (
          <div
            className={clsx(
              'flex items-center px-16 rounded-md hover:text-white hover:bg-primary-500 z-10',
              menuItemsRef?.current[index]?.checked ? 'bg-primary-900 text-white font-bold' : ''
            )}
            key={item}
          >
            <input
              ref={(element: HTMLInputElement) => {
                menuItemsRef.current[index] = element
              }}
              type="radio"
              name="categories"
              id={item}
              value={item}
              onChange={(e) => setCategory(e.target.value)}
              className="cursor-pointer appearance-none "
            />
            <label className="cursor-pointer py-12 w-full" htmlFor={item}>
              {item}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}
